import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AlignBottomIcon } from '../icons';
import { ToolbarButton } from '../ui';
import { getAlignToContainer, getSelectedObjectsIDs } from '../editor';
import { getCurrentPiece, alignObjectsToBottom } from '../project';

const ButtonAlignBottom = ({ disabled, onClick }) => {
  if (disabled) {
    return null;
  }

  return <ToolbarButton icon={<AlignBottomIcon />} onClick={onClick} />;
};

ButtonAlignBottom.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};

const reduxConnector = connect(
  state => {
    let container = getCurrentPiece(state);
    if (!getAlignToContainer(state)) {
      container = null;
    }

    const ids = getSelectedObjectsIDs(state);
    let disabled = true;
    if (ids.size >= 1) {
      disabled = false;
    }
    return { ids, disabled, container };
  },
  { alignObjectsToBottom },
  ({ ids, container, ...state }, actions) => ({
    ...state,
    onClick: () => actions.alignObjectsToBottom({ ids, container }),
  }),
);

export default reduxConnector(ButtonAlignBottom);
